export { default } from "./StarsTheme";
